<template>
    <div id="search-page">
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="d-none d-xl-block col-3">
                    <catalog-categories></catalog-categories>
                </div>
                <div class="col-xl-9">
                    <h1 class="as-h2 mb-40">
                        Результаты поиска
                        <span v-if="search_text">по запросу "{{search_text}}"</span>
                    </h1>

                    <div class="account-navigate" v-if="products || news || services || shares || projects || rules">

                        <nav>
                            <ul class="pl-0 d-flex">
                                <li @click="active = 1" v-if="products">
                                    <span class="h6" :class="{'active': active == 1}">Товары</span>
                                </li>

                                <li @click="active = 2" v-if="news">
                                    <span class="h6" :class="{'active': active == 2}">Новости</span>
                                </li>

                                <li @click="active = 3" v-if="projects">
                                    <span class="h6" :class="{'active': active == 3}">Проекты</span>
                                </li>

                                <li @click="active = 4" v-if="rules">
                                    <span class="h6" :class="{'active': active == 4}">Правила</span>
                                </li>

                                <li @click="active = 5" v-if="services">
                                    <span class="h6" :class="{'active': active == 5}">Услуги</span>
                                </li>


                                <li @click="active = 6" v-if="shares">
                                    <span class="h6" :class="{'active': active == 6}">Акции</span>
                                </li>
                            </ul>
                        </nav>
                    </div>


                    <div v-if="active == 1 && products">
                        <div class="row">
                            <div class="col-6 col-sm-4 col-lg-3 mb-40" v-for="item in products">
                                <catalog-card :item="item"></catalog-card>
                            </div>
                        </div>
                        <div v-if="products_count > 12">
                            <b-pagination
                                v-model="search.page_products"
                                :total-rows="products_count"
                                :per-page="perPageProducts"
                            ></b-pagination>
                        </div>
                    </div>


                    <div v-if="active == 2 && news">
                        <div class="grid-container">
                            <div class="box-grid" v-for="item in news"
                                 :key="item.id">
                                <news-app :item="item"></news-app>
                            </div>
                        </div>
                        <div v-if="news_count > 12">
                            <b-pagination
                                v-model="search.page_news"
                                :total-rows="news_count"
                                :per-page="perPage"
                            ></b-pagination>
                        </div>
                    </div>


                    <div v-if="active == 3 && projects">
                        <div class="grid-container">
                            <div class="box-grid" v-for="item in projects"
                                 :key="item.id">
                                <router-link :to="'/projects/' + item.slug">
                                    <img :src="'/storage/' + item.image" :alt="item.title">
                                    <span class="title-4 color-text-white">{{item.title}}</span>
                                </router-link>
                            </div>
                        </div>
                        <div v-if="products_count > 12">
                            <b-pagination
                                v-model="search.page_projects"
                                :total-rows="products_count"
                                :per-page="perPage"
                            ></b-pagination>
                        </div>
                    </div>


                    <div v-if="active == 4 && rules">
                        <div class="grid-container">
                            <div class="box-grid" v-for="item in rules"
                                 :key="item.id">
                                <router-link :key="item.id"
                                             :to="'/projects/' + item.slug">
                                    <img :src="'/storage/' + item.image" :alt="item.title">
                                </router-link>
                            </div>
                        </div>
                        <div v-if="rules_count > 12">
                            <b-pagination
                                v-model="search.page_rules"
                                :total-rows="rules_count"
                                :per-page="perPage"
                            ></b-pagination>
                        </div>
                    </div>


                    <div v-if="active == 5 && services">
                        <div class="grid-container">
                            <div class="box-grid" v-for="(item, i) in services"
                                 :key="i">
                                <router-link :to="'/services/' + item.slug">
                                    <img :src="'/storage/' + item.image">
<!--                                                                            <img src="/storage/vSHpsbRTzuWCkN9zL6XIUkHHKtm4nQgaJSoQdnhw.jpeg">-->
                                    <span class="title-4 color-text-white">{{item.title}}</span>
                                </router-link>
                            </div>
                        </div>
                        <div v-if="services_count > 12">
                            <b-pagination
                                v-model="search.page_services"
                                :total-rows="services_count"
                                :per-page="perPage"
                            ></b-pagination>
                        </div>
                    </div>


                    <div v-if="active == 6 && shares">
                        <div class="grid-container">
                            <div class="box-grid" v-for="item in shares"
                                 :key="item.id">
                                <router-link :to="'/shares/' + item.slug">
                                    <img :src="'/storage/' + item.image" :alt="item.title">
                                    <!--                                <h4 class="color-text-white">{{item.title}}</h4>-->
                                </router-link>
                            </div>
                        </div>

                        <div v-if="shares_count > 12">
                            <b-pagination
                                v-model="search.page_shares"
                                :total-rows="shares_count"
                                :per-page="perPage"
                            ></b-pagination>
                        </div>
                    </div>


                    <div v-if="!products && !news && !services && !shares && !projects && !rules">
                        К сожалению, по Вашему запросу ничего не найдено.
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading" class="loading-box">
            <b-spinner></b-spinner>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                breadcrumb: [
                    {
                        text: 'Главная',
                        to: { name: 'pages-index' }
                    },
                    {
                        text: 'Результаты поиска',
                        active: true
                    }
                ],

                search_text: null,
                search: {
                    page_products: 1,
                    page_news: 1,
                    page_services: 1,
                    page_shares: 1,
                    page_projects: 1,
                    page_rules: 1,
                },

                products: null,
                news: null,
                projects: null,
                rules: null,
                services: null,
                shares: null,

                products_count: 0,
                news_count: 0,
                projects_count: 0,
                rules_count: 0,
                services_count: 0,
                shares_count: 0,

                active: 1,
                perPage: 12,
                perPageProducts: 20,

                loading: false
            }
        },

        watch: {
            $route() {
                this.search_text = this.$route.query.search;
                this.searchItems();
            },
            'search.page_products'() {
                this.searchItems();
            }
        },

        mounted() {
            this.getSeoInfo();
            this.search_text = this.$route.query.search;
            this.searchItems();
        },

        methods: {
            searchItems() {
                if(this.search_text) {
                    this.products = null;
                    this.news = null;
                    this.projects = null;
                    this.rules = null;
                    this.services = null;
                    this.shares = null;

                    let search_items = {
                        search_text: this.search_text,
                        page_products: this.search.page_products - 1,
                        page_news: this.search.page_news - 1,
                        page_services: this.search.page_services - 1,
                        page_shares: this.search.page_shares - 1,
                        page_projects: this.search.page_projects - 1,
                        page_rules: this.search.page_rules - 1,
                    };
                    this.loading = true;
                    this.scrollTop();
                    let url = '/api/search';
                    axios.post(url, search_items)
                        .then(response => {
                            if(response.data.shares_count !== 0) {
                                this.shares = response.data.shares;
                                this.shares_count = response.data.shares_count;
                                this.active = 6;
                            }
                            else this.shares = null;

                            if(response.data.services_count !== 0) {
                                this.services = response.data.services;
                                this.services_count = response.data.services_count;
                                this.active = 5;
                            }
                            else this.services = null;

                            if(response.data.rules_count !== 0) {
                                this.rules = response.data.rules;
                                this.rules_count = response.data.rules_count;
                                this.active = 4;
                            }
                            else this.rules = null;

                            if(response.data.projects_count !== 0) {
                                this.projects = response.data.projects;
                                this.projects_count = response.data.projects_count;
                                this.active = 3;
                            }
                            else this.projects = null;

                            if(response.data.news_count !== 0) {
                                this.news = response.data.news;
                                this.news_count = response.data.news_count;
                                this.active = 2;
                            }
                            else this.news = null;

                            if(response.data.products_count !== 0) {
                                this.products = response.data.products;
                                this.products_count = response.data.products_count;
                                this.active = 1;
                            }
                            else this.products = null;

                            this.loading = false;
                        });
                }
            },

            scrollTop() {
                document.getElementById('app').scrollIntoView({behavior: "smooth"})
            },

            getSeoInfo(){
                let url = '/api/seo';

                let params = {
                    url: 'search',
                };

                axios.post(url, params)
                    .then(response => {
                        let seoInfo = response.data.seoInfo

                        document.title = seoInfo?.seo_title ? seoInfo?.seo_title : 'Фотопрокат "MRental" - прокат фото, видео и кинотехники в Минске без залога.';
                        let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc : 'Прокат фото, видео, кинотехники и оборудования в Минске, Фотопрокат "MRental"';
                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);

                        this.setDocTitleAndDescr();

                    })
                    .catch(error => {
                        if (error) this.loading = false;
                    })
            },
            setDocTitleAndDescr() {
                if (this.filter.filter.page > 1) {
                    let title = document.title;
                    let description = document.querySelector('meta[name="description"]').getAttribute("content");
                    title += ', Cтраница -' + this.filter.filter.page;
                    description += ', Cтраница -' + this.filter.filter.page
                    console.log(title, 'title');
                    console.log(description, 'description')
                    document.title = title;
                    document.querySelector('meta[name="description"]').setAttribute("content", description);
                    document.querySelector('meta[name="robots"]').setAttribute("content",  'noindex, follow');
                } else {
                    document.querySelector('meta[name="robots"]').setAttribute("content",  'index, follow');
                }
            },

        }
    }
</script>
